import config from '@/config';
import isSSR from '@/utils/isSSR';
import { useQuery, useQueryClient } from '@tanstack/vue-query';
import axios, { isAxiosError } from 'axios';
import { onServerPrefetch, ref, type Ref } from 'vue';
import { CustomError } from '@/utils/errors';
import logger from '@/app/logger';

export const fetchListingQueryKey = 'listing';
export const fetchListingQuery = async (listingId: string) => {
  const url = isSSR ? `${config.BACKEND.URL}/listings/${listingId}` : `/api/listing/${listingId}`;
  logger.info(`Fetching listing data: ${url}...`);
  return axios
    .get(url)
    .then((res) => {
      logger.info('Got listing response');
      return res.data;
    })
    .catch((err) => {
      if (isAxiosError(err) && err.response?.status === 404) {
        throw new CustomError('Can not find listing id ' + listingId, 404, 'listing' as keyof typeof config.PAGE_NAMES);
      }
      return Promise.reject(err);
    });
};

export default function useListingData(listingId: Ref<string>, enabled: Ref<boolean> = ref(true)) {
  const query = useQuery({
    queryKey: [fetchListingQueryKey, listingId],
    queryFn: () => fetchListingQuery(listingId.value),
    enabled: enabled,
  });

  onServerPrefetch(async () => {
    if (listingId.value) {
      const queryClient = useQueryClient();
      await queryClient.prefetchQuery({ queryKey: [fetchListingQueryKey, listingId] });
    }
  });

  return query;
}
